import React, { Component } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Input, InputNumber, Switch, Space, Popconfirm, message } from "antd";

const FormItem = Form.Item;

class SeriesVenta extends Component {
  state = {
    series: [],
    loading: false,
    modalVisible: false,
    editandoId: null,
  };

  formRef = React.createRef();

  componentDidMount() {
    this.consultarSeries();
  }

  consultarSeries() {
    this.setState({ loading: true });
    axios
      .post(
        "serieventas/selectSeriesVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, series: Array.isArray(res.data) ? res.data : [] });
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron consultar las series");
      });
  }

  abrirModalAgregar = () => {
    this.setState({ modalVisible: true, editandoId: null });
    setTimeout(() => this.formRef.current?.resetFields(), 0);
  };

  abrirModalEditar = (serie) => {
    this.setState({ modalVisible: true, editandoId: serie._id });
    setTimeout(() => this.formRef.current?.setFieldsValue(serie), 0);
  };

  cerrarModal = () => {
    this.setState({ modalVisible: false, editandoId: null });
  };

  onFinish = (values) => {
    const url = this.state.editandoId ? "serieventas/editarSerieVenta" : "serieventas/agregarSerieVenta";
    const payload = this.state.editandoId
      ? { ...values, serieVentaId: this.state.editandoId, empresaId: this.props.empresaId }
      : { ...values, empresaId: this.props.empresaId };

    axios
      .post(url, payload, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Serie guardada");
          this.cerrarModal();
          this.consultarSeries();
        } else {
          message.error(res.data.error || "No se pudo guardar la serie");
        }
      })
      .catch(() => message.error("No se pudo guardar la serie"));
  };

  desactivarSerie = (serieVentaId) => {
    axios
      .post(
        "serieventas/deshabilitarSerieVenta",
        { serieVentaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Serie desactivada");
          this.consultarSeries();
        }
      });
  };

  activarSerie = (serieVentaId) => {
    axios
      .post(
        "serieventas/habilitarSerieVenta",
        { serieVentaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Serie activada");
          this.consultarSeries();
        }
      });
  };

  render() {
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre" },
      { title: "Serie Facturas", dataIndex: "serieFacturas", key: "serieFacturas" },
      { title: "Folio Facturas", dataIndex: "folioFacturas", key: "folioFacturas" },
      { title: "Serie Remisiones", dataIndex: "serieRemisiones", key: "serieRemisiones" },
      { title: "Folio Remisiones", dataIndex: "folioRemisiones", key: "folioRemisiones" },
      { title: "Predeterminada", dataIndex: "predeterminada", key: "predeterminada", render: (v) => (v ? "Sí" : "No") },
      { title: "Estado", dataIndex: "activa", key: "activa", render: (v) => (v ? "Activa" : "Inactiva") },
      {
        title: "Acciones",
        key: "acciones",
        render: (_, serie) => (
          <Space>
            <Button size="small" onClick={() => this.abrirModalEditar(serie)}>Editar</Button>
            {serie.activa ? (
              <Popconfirm title="¿Desactivar esta serie?" onConfirm={() => this.desactivarSerie(serie._id)}>
                <Button size="small" danger>Desactivar</Button>
              </Popconfirm>
            ) : (
              <Button size="small" onClick={() => this.activarSerie(serie._id)}>Activar</Button>
            )}
          </Space>
        ),
      },
    ];

    return (
      <div style={{ marginTop: 24, marginBottom: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Series y Folios Personalizados</h3>
          <Button type="primary" onClick={this.abrirModalAgregar}>Agregar Serie</Button>
        </div>
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={this.state.series}
          loading={this.state.loading}
          pagination={false}
          size="small"
        />
        <Modal
          title={this.state.editandoId ? "Editar Serie" : "Agregar Serie"}
          visible={this.state.modalVisible}
          onCancel={this.cerrarModal}
          onOk={() => this.formRef.current?.submit()}
          destroyOnClose
        >
          <Form ref={this.formRef} layout="vertical" onFinish={this.onFinish}>
            <FormItem name="nombre" label="Nombre" rules={[{ required: true, message: "Ingresa el nombre" }]}>
              <Input placeholder="Ej. Serie B" />
            </FormItem>
            <FormItem name="serieFacturas" label="Serie de Facturas" rules={[{ required: true, message: "Ingresa la serie de facturas" }]}>
              <Input placeholder="Ej. B" />
            </FormItem>
            <FormItem name="folioFacturas" label="Folio Inicial de Facturas" rules={[{ required: true, message: "Ingresa el folio inicial de facturas" }]}>
              <InputNumber min={1} style={{ width: "100%" }} />
            </FormItem>
            <FormItem name="serieRemisiones" label="Serie de Remisiones" rules={[{ required: true, message: "Ingresa la serie de remisiones" }]}>
              <Input placeholder="Ej. B" />
            </FormItem>
            <FormItem name="folioRemisiones" label="Folio Inicial de Remisiones" rules={[{ required: true, message: "Ingresa el folio inicial de remisiones" }]}>
              <InputNumber min={1} style={{ width: "100%" }} />
            </FormItem>
            <FormItem name="predeterminada" label="Predeterminada" valuePropName="checked">
              <Switch />
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default SeriesVenta;
